import { useQuery } from "@tanstack/react-query";

export interface Theme {
  "@id": string;
  "@type": string;
  name: string;
  code: string;
  description: string;
  icon: {
    "@id": string;
    "@type": string;
    type: string;
    slug: string;
    id: string;
  };
  id: string;
}

export const useGetThemeQuery = () => {
  return useQuery<{ "hydra:member": Theme[] }>({
    queryKey: ["themes"],
    queryFn: async () => {
      const response = await fetch(`/api/theme`);
      if (!response.ok) {
        throw new Error("Erreur lors de la récupération des thèmes");
      }
      return response.json();
    },
  });
};
